if (!customElements.get("size-guide-display")) {
	customElements.define(
		"size-guide-display",
		class SizeGuideDisplay extends HTMLElement {
			constructor() {
				super()

				var sg_template = document.querySelector(".size-guide-template")
				if (!sg_template) {
					this.closest(".product__accordion").classList.add("hide")
					return
				}

				//get innerHTML and append
				const templateContent = sg_template.content

				// Create a deep clone of the template content
				const clone = templateContent.cloneNode(true)

				// Append the cloned content to the web component
				this.appendChild(clone)
			}
		}
	)
}
if (!customElements.get("size-guide")) {
	customElements.define(
		"size-guide",
		class SizeGuide extends HTMLElement {
			constructor() {
				super()
				//init modal
			}
		}
	)
}
